<div class="mt-filter filter-date">
    <div class="title">
        <span class="label">{{'date' | lang}}</span>
        <span *ngIf="filter.required" class="mandatory">*</span>
    </div>

    <div class="filter">
        <app-range-datepicker (changeDates)="changeSelectedDate($event)" [daterangeOptions]="daterangeOptions"></app-range-datepicker>
    </div>
</div>